import StorageService from "@/services/StorageService";
import CryptoService from "@/services/CryptoService";
import { isRemember } from "@/helper/RememberMe";
import store from "@/store";
export default class UserService {
    static getStorage() {
        return isRemember() ? localStorage : sessionStorage;
    }
    static getUser() {
        return this.getFromStorage("user");
    }
    static getToken() {
        return this.getStorage().getItem("token");
    }
    static getRefreshToken() {
        return this.getFromStorage("refToken");
    }
    static getTokenInfo() {
        return UserService.getFromStorage("tokenInfo");
    }
    static setUser(data) {
        const encode = CryptoService.encode(JSON.stringify(data));
        this.getStorage().setItem("user", String(encode));
    }
    static setRefreshToken(data) {
        const encode = CryptoService.encode(JSON.stringify(data));
        this.getStorage().setItem("refToken", String(encode));
    }
    static setTokenInfo(data) {
        const encode = CryptoService.encode(JSON.stringify(data));
        this.getStorage().setItem("tokenInfo", String(encode));
    }
    static clearUser() {
        this.getStorage().removeItem("user");
        this.getStorage().removeItem("token");
        this.getStorage().removeItem("refToken");
    }
    static listenLocalStorageAndClearUser() {
        StorageService.listenStorage(async (val) => {
            if ((val.key == "user" || val.key == "token") && val.newValue == null) {
                this.clearUser();
                await store.dispatch("auth/signOut").then(() => window.location.reload());
            }
        });
    }
    static getRole() {
        return this.getTokenInfo()?.role;
    }
    static getFromStorage(key) {
        const data = this.getStorage().getItem(key);
        if (!data) {
            return null;
        }
        const decode = CryptoService.decode(data.toString());
        if (!decode) {
            return null;
        }
        return JSON.parse(decode);
    }
    static getDrivingSchoolId() {
        return this.getTokenInfo()?.drivingSchoolId;
    }
}
